import { Toasts } from '@fourthwall/components'

import type { FieldValues } from '../EmailNotifications.types'
import { useNotificationPreferencesMutation } from '../queries/useNotificationPreferencesMutation'
import { useNotificationPreferencesQuery } from '../queries/useNotificationPreferencesQuery'

export const useEmailNotifications = () => {
  const { notificationPreferencesQuery, setNotificationPreferencesData } =
    useNotificationPreferencesQuery()
  const { notificationPreferencesMutation } = useNotificationPreferencesMutation()

  const handleSubmit = async (values: FieldValues) => {
    const mailPreferences = { ...values }

    if (!mailPreferences.newDirectMessage) {
      mailPreferences.newDirectMessageWithTip = false
    }

    if (!mailPreferences.newPostComments) {
      mailPreferences.newPostCommentsReply = false
    }

    const data = await notificationPreferencesMutation.mutateAsync([{ mailPreferences }])
    setNotificationPreferencesData(data)
    Toasts.notify('Email notifications settings have been updated', { type: 'success' })
  }

  return {
    handleSubmit,
    initialValues: notificationPreferencesQuery.data?.mailPreferences,
  }
}
